<template>
  <div 
    v-if="shouldShowIcpInfo"
    class="icp-info" 
    :class="{ 
      'fixed-position': isFixed,
      'at-bottom': !isFixed 
    }"
  >
    <div class="icp-content">
      <span class="company-name">网信算备310104666296401240017号</span>
      <span class="company-info">Shanghai-JinShengYuLiang-202503260042</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IcpInfo',
  props: {
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabbarHeight: 60,
      icpHeight: 40
    }
  },
  computed: {
    tabbarHeightPx() {
      return this.tabbarHeight + 'px';
    },
    shouldShowIcpInfo() {
      // 当路由是 /jsyl 时不展示备案信息组件
      if (this.$route && this.$route.path) {
        return !this.$route.path.startsWith('/jsyl');
      }
      return true;
    }
  },
  watch: {
    // 监听路由变化，重新计算是否显示组件
    '$route'(newRoute, oldRoute) {
      if (newRoute.path !== oldRoute.path) {
        this.$nextTick(() => {
          if (this.shouldShowIcpInfo) {
            this.checkPositioning();
          }
        });
      }
    },
    // 监听组件显示状态变化，重新计算定位
    shouldShowIcpInfo(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.checkPositioning();
        });
      }
    }
  },
  mounted() {
    if (this.shouldShowIcpInfo) {
      this.initPositioning();
      this.bindEvents();
    }
  },
  beforeDestroy() {
    this.unbindEvents();
  },
  methods: {
    initPositioning() {
      // 初始化时等待页面完全渲染
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkPositioning();
        }, 100);
      });
    },
    
    bindEvents() {
      this.debouncedCheck = this.debounce(this.checkPositioning, 150);
      window.addEventListener('resize', this.debouncedCheck);
      window.addEventListener('load', this.debouncedCheck);
      
      // 监听DOM变化
      this.observer = new MutationObserver(this.debouncedCheck);
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    },
    
    unbindEvents() {
      window.removeEventListener('resize', this.debouncedCheck);
      window.removeEventListener('load', this.debouncedCheck);
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.positionTimer) {
        clearTimeout(this.positionTimer);
      }
    },
    
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    checkPositioning() {
      // 如果不应该显示组件，直接返回
      if (!this.shouldShowIcpInfo) {
        return;
      }
      
      this.$nextTick(() => {
        try {
          const viewportHeight = window.innerHeight;
          
          // 获取实际的 tabbar 高度
          const tabbarContainer = document.querySelector('.tabbar-container');
          if (tabbarContainer) {
            this.tabbarHeight = tabbarContainer.offsetHeight;
          }
          
          // 获取页面内容的实际高度
          // 排除当前备案信息组件的高度
          this.isFixedPosition = false; // 临时设置为false来获取正确的内容高度
          
          setTimeout(() => {
            const bodyRect = document.body.getBoundingClientRect();
            const documentHeight = Math.max(
              document.body.scrollHeight,
              document.body.offsetHeight,
              document.documentElement.clientHeight,
              document.documentElement.scrollHeight,
              document.documentElement.offsetHeight
            );
            
            // 减去备案信息组件的高度来计算实际内容高度
            const contentHeight = documentHeight - this.icpHeight;
            
            // 计算可用空间（视口高度 - tabbar高度）
            const availableSpace = viewportHeight - this.tabbarHeight;
            
            // 如果内容高度小于可用空间，说明不满一屏，使用固定定位
            this.isFixedPosition = contentHeight <= availableSpace;
            
            console.log('定位计算:', {
              viewportHeight,
              tabbarHeight: this.tabbarHeight,
              contentHeight,
              availableSpace,
              isFixedPosition: this.isFixedPosition
            });
          }, 50);
          
        } catch (error) {
          console.warn('IcpInfo 定位计算出错:', error);
          // 出错时默认使用普通定位
          this.isFixedPosition = false;
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.icp-info {
  width: 100%;
  padding: 8px 16px;
  box-sizing: border-box;
  
  &.fixed-position {
    position: fixed;
    bottom: 68px;
    left: 0;
    right: 0;
    z-index: 998;
  }
  
  &.at-bottom {
    position: unset;
    margin-bottom: 0;
  }
}

.icp-content {
  text-align: center;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.company-name {
  font-size: 12px;
  color: #8E8E93;
  line-height: 1.5;
}

.company-info {
  font-size: 12px;
  color: #8E8E93;
  letter-spacing: 0.2px;
  line-height: 1.5;
  margin-top: 1px;
}

@media (max-width: 768px) {
  .icp-info {
    padding: 6px 16px;
  }
}
</style> 